/**
 * Country display normalization for DRPACK grouping.
 * Turkish locale lowercases "I" → "ı", so alias keys must fold ı→i.
 */

const COUNTRY_DISPLAY_ALIASES = {
  irak: "Irak",
  iraq: "Irak"
};

export function foldCountryKey(value) {
  return String(value || "")
    .trim()
    .toLocaleLowerCase("tr")
    .replace(/\u0131/g, "i") // ı
    .replace(/\u0130/g, "i") // İ
    .normalize("NFC");
}

export function normalizeCountryName(raw, fallback = "") {
  const s = String(raw || "").trim();
  if (!s) return fallback;
  const folded = foldCountryKey(s);
  if (COUNTRY_DISPLAY_ALIASES[folded]) return COUNTRY_DISPLAY_ALIASES[folded];
  return s;
}
